// 按钮权限控制
// 账户的type值 -1 超级管理员，0=管理员，1=普通用户，2=医生，99=机器

import { local } from "@/utils/storage.js";

export default {
  mounted(el, binding) {
    const { value } = binding;
    const type = local.get("type");
    if(typeof value === 'function'){
      if (!value(type)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    }else if(value !== type) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  },
};
